// ------------------------------------
// Constants
// ------------------------------------
export const SELECT_SERVICE = 'SELECT_SERVICE'

// ------------------------------------
// Actions
// ------------------------------------
export function selectService (value = null) {
  return {
    type    : SELECT_SERVICE,
    payload : value
  }
}

export const actions = { selectService }

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [SELECT_SERVICE] : (state, action) => action.payload
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = null
export default function selectedServiceReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/selectedService.js